import type React from "react";
import type { ArtistArtwork } from "../types";
import { DefaultTheme } from "./DefaultTheme";

// Each theme is a React component that receives the artwork + image URL and
// renders the entire card however it likes (background, frame, layout, etc.).
//
// To register a new theme:
//   1. Create themes/<MyTheme>.tsx exporting a React.FC<ArtistArtworkCardProps>
//   2. Add it to the `registry` map below under a unique slug
//   3. Admins can then assign that slug to any contributor via /admin/contributors

export interface ArtistArtworkCardProps {
  artwork: ArtistArtwork;
  pictureUrl: string;
  onClick?: () => void;
}

export type ArtistArtworkCardTheme = React.FC<ArtistArtworkCardProps>;

const registry: Record<string, ArtistArtworkCardTheme> = {
  default: DefaultTheme,
};

export function getArtistTheme(themeName?: string | null): ArtistArtworkCardTheme {
  if (!themeName) return DefaultTheme;
  return registry[themeName] ?? DefaultTheme;
}

export function listArtistThemes(): string[] {
  return Object.keys(registry);
}
